// extracted by mini-css-extract-plugin
export default {"root":"MediaOverlay_root__woyS-"};